<template>
  <el-dialog
    class="rc-dialog"
    :title="curdTitle"
    :visible.sync="CUFlag"
    @close="closeDialog"
    :close-on-click-modal="false"
    width="50%"
  >
    <el-form
      ref="curdForm"
      size="small"
      :model="curdForm"
      :rules="rules"
      label-position="right"
      label-width="100px"
    >
      <el-row :gutter="12">
        <el-col>
          <el-form-item label="消息内容：" prop="smsContent" required>
            <el-input v-model="curdForm.smsContent" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="群发方式：" prop="sendTypes" required>
            <el-checkbox-group v-model="curdForm.sendTypes">
              <el-checkbox
                v-for="item in sendType"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="CUFlag = false" title="返回"></butn>
      <butn btntype="primary" @click="createData" title="发送"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Bus from "../Bus";
import { sendMessage } from "@/api/classWork";
import { getDataMap } from "@/api/sysParam";

export default {
  components: { butn },
  data() {
    return {
      Bus,
      deptTreeList: [],

      curdTitle: "",
      CUFlag: false,
      curdForm: {
        mqSendType: "",
        sendTypes: [],
        smsContent: "",
        userIds: [],
        workId: "",
      },
      workName: "",
      deadline: "",
      sendType: [],
      rules: {
        smsContent: [
          {
            required: true,
            message: "请输入消息内容",
            trigger: ["blur", "change"],
          },
        ],
        sendTypes: [
          {
            required: true,
            message: "请选择群发方式",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    let _this = this;
    Bus.$on("SendMessage", function (item) {
      _this.$nextTick(() => {
        _this.curdTitle = "发消息";
        _this.curdForm.workId = item.workId;
        _this.curdForm.userIds = item.userIds;
        _this.workName = item.workName;
        _this.deadline = item.deadline;
        _this.curdForm.smsContent = `您好！您的作业${_this.workName}尚未提交，截止时间${_this.deadline}，请及时提交。`;
        _this.CUFlag = true;
      });
    });
    getDataMap("MQ_SEND_TYPE").then((res) => {
      if (!res || res.code != 0) return;
      this.sendType = res.data
        .sort(function (a, b) {
          return parseInt(a.paramKey) - parseInt(b.paramKey);
        })
        .map((ele) => {
          ele.paramKey = parseInt(ele.paramKey);
          return ele;
        });
    });
  },
  methods: {
    //提交数据
    createData() {
      this.$refs.curdForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          sendMessage(this.curdForm).then((res) => {
            this.loading = false;
            if (res && res.code == 0) {
              this.$message.success(res.msg);
              Bus.$emit("reload");
              this.CUFlag = false;
            }
          });
        }
      });
    },
    closeDialog() {
      this.CUFlag = false;
      // 点击取消 数据重置
      this.$refs["curdForm"].resetFields();
    },
  },
};
</script>

<style lang="scss" scoped></style>
